import { createSlice } from "@reduxjs/toolkit";
import {
  getTableListData,
  getTableMetaData,
  createOrUpdateListData,
  getResetDataManagement,
} from "../services/dataMgt";

interface DataMgtState {
  tableListStatus: string;
  tableListLoading: boolean;
  metadataIsLoading: boolean;
  metaConfigData: unknown[];
  tableListData: unknown[];
  isDMPending: boolean;
  isDMSave: boolean;
  isDMDelete: boolean;
  isDMError: boolean;
}

const initialState: DataMgtState = {
  tableListStatus: "idle",
  tableListLoading: false,
  metadataIsLoading: false,
  metaConfigData: [],
  tableListData: [],
  isDMPending: false,
  isDMSave: false,
  isDMDelete: false,
  isDMError: false,
};

const dataMgtSlice = createSlice({
  name: "dataMgt",
  initialState,
  reducers: {
    clearState: (state) => {
      state.metaConfigData = [];
      state.tableListData = [];
      state.tableListLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTableListData.pending, (state) => {
        state.tableListStatus = "pending";
        state.tableListLoading = true;
      })
      .addCase(getTableListData.fulfilled, (state, action) => {
        const payload = action.payload as {
          tableListData?: { data?: { data?: unknown[] } };
        };
        state.tableListStatus = "success";
        state.tableListLoading = false;
        state.tableListData = payload.tableListData?.data?.data || [];
      })
      .addCase(getTableListData.rejected, (state) => {
        state.tableListStatus = "rejected";
        state.tableListLoading = false;
      })
      .addCase(createOrUpdateListData.pending, (state) => {
        state.isDMPending = true;
        state.isDMSave = false;
        state.isDMError = false;
        state.isDMDelete = false;
      })
      .addCase(createOrUpdateListData.fulfilled, (state, action) => {
        const { payload } = action;
        state.isDMPending = false;
        state.isDMError = false;
        state.isDMSave = payload !== "delete";
        state.isDMDelete = payload === "delete";
      })
      .addCase(createOrUpdateListData.rejected, (state) => {
        state.isDMPending = false;
        state.isDMError = true;
        state.isDMSave = false;
        state.isDMDelete = false;
      })

      // Get Table Metadata
      .addCase(getTableMetaData.pending, (state) => {
        state.tableListStatus = "pending";
        state.metadataIsLoading = true;
        state.metaConfigData = [];
      })
      .addCase(getTableMetaData.fulfilled, (state, action) => {
        const payload = action.payload as { headerData?: { data?: unknown[] } };
        state.tableListStatus = "success";
        state.metadataIsLoading = false;
        state.metaConfigData = payload.headerData?.data || [];
      })
      .addCase(getTableMetaData.rejected, (state) => {
        state.tableListStatus = "rejected";
        state.metadataIsLoading = false;
        state.metaConfigData = [];
      })
      .addCase(getResetDataManagement, (state) => {
        state.tableListStatus = "idle";
        state.isDMPending = false;
        state.isDMSave = false;
        state.isDMDelete = false;
        state.isDMError = false;
      });
  },
});

export const { clearState } = dataMgtSlice.actions;

export default dataMgtSlice.reducer;
